import jsonata from 'jsonata';
import { isNil } from 'lodash';

import { logger } from '@assess/shared/logger';
import { Nullable } from '@assess/shared/type-utilities';

const fnLogger = logger.child({ context: 'jsonataEval' });

export const jsonataEval = async (expression: Nullable<string>, source: Nullable<any>) => {
  if (!expression?.trim?.()?.length) {
    fnLogger.warn('Expression is empty; skipping');

    return undefined;
  }

  if (isNil(source)) {
    fnLogger.warn('Source is empty; skipping');

    return undefined;
  }

  try {
    const compiled = jsonata(expression);

    return await compiled.evaluate(source);
  } catch (error: any) {
    fnLogger.error({ error, expression }, 'Error occurred while compiling/evaluating expression');

    return undefined;
  }
};
